import { ThemeProvider as MaterialThemeProvider } from '@mui/material';
import { useLang } from 'contexts/intl';
import { ReactNode } from 'react';
import { theme } from 'themes/default';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

const cacheRtl = (dir: string) =>
  createCache({
    key: dir === 'rtl' ? 'cssrtl' : 'cssltr',
    prepend: true,
    stylisPlugins: dir === 'rtl' ? ([prefixer, rtlPlugin] as any) : [],
  });

export function ThemeProvider({ children }: { children: ReactNode }) {
  const { dir } = useLang();
  const updatedTheme = { ...theme, direction: dir };

  return (
    <CacheProvider value={cacheRtl(dir)}>
      <MaterialThemeProvider theme={updatedTheme}>{children}</MaterialThemeProvider>
    </CacheProvider>
  );
}
